<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
</style>

<template>
  <div>
    <div>
      <div class="d-flex justify-content-between">
        <div>
          <h5>Casing Tally</h5>
          <p style="font-size: 12px; margin-top: -0.5rem">
            Cumulative Length:
            <b>{{ totalLength }}</b> m
          </p>
          <p style="font-size: 12px; margin-bottom: -1rem; margin-top: -0.5rem">
            <b-icon icon="info" variant="success"></b-icon>&nbsp;Select table
            row for more option.
          </p>
        </div>
        <div>
          <b-button-group v-if="editable">
            <b-button variant="outline-primary" size="sm" @click="refreshGrid"
              >Refresh</b-button
            >
          </b-button-group>
        </div>
      </div>
      <br />
      <div class="overflow-auto">
        <DxDataGrid
              id="casing-tally-grid"
              ref="casingTallyGrid"
              :data-source="casingDataSource"
              :show-borders="false"
              :show-column-lines="false"
              :show-row-lines="true"
              column-resize-mode="nextColumn"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :cell-hint-enabled="true"
              :word-wrap-enabled="true"
              :column-auto-width="false"
              :column-width="100"
              :height="300"
              @row-inserted="savedRows"
              @row-updated="updatedRows"
              @row-removed="removedRows"
              @selection-changed="onSelectionChanged"
            >
              <DxPaging :enabled="true" :page-size="5" />
              <DxScrolling column-rendering-mode="virtual"/>
              <DxSelection mode="single"/>
              <DxEditing
                :allow-updating="true"
                :allow-adding="true"
                :allow-deleting="true"
                :use-icons="true"
                mode="row"/>
              <DxColumn
                type="buttons"
                width="5%"
              >
                <GridButton name="edit"/>
                <GridButton name="delete"/>
              </DxColumn>
              <DxColumn caption="No." cell-template="rowNoTemplate" width="5%" />
              <template #rowNoTemplate="{ data }">
                {{ data.rowIndex + 1 }}
              </template>
              <DxColumn :width="200" :visible="true" data-field="assemblyType" data-type="string" caption="Assembly Type">
                <DxLookup
                    :data-source="optionsComboAssemblyType"
                    value-expr="value"
                    display-expr="text"/>
              </DxColumn>
              <DxColumn :visible="true" data-field="runNo" data-type="numeric" caption="Run No." />
              <DxColumn :width="200" :visible="true" data-field="grade" data-type="string" caption="Grade">
                <DxLookup
                    :data-source="optionsComboGrade"
                    value-expr="value"
                    display-expr="text"/>
              </DxColumn>
              <DxColumn :visible="true" data-field="weight" data-type="numeric" caption="Weight" />
              <DxColumn :visible="true" data-field="connection" data-type="text" caption="Connection" />
              <DxColumn :visible="true" data-field="centralizer" data-type="text" caption="Centralizer" />
              <DxColumn :visible="true" data-field="length" data-type="numeric" caption="Length" />
              <DxColumn :visible="true" data-field="remarks" data-type="text" caption="Remarks" />
        </DxDataGrid>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import { formComputed, formMethods } from '@state/helpers'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxFormItem,
  DxLookup,
  DxSelection,
  DxScrolling,
  DxButton as GridButton
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import CustomStore from 'devextreme/data/custom_store'
import mapApiUrl from '@/src/utils/api-mapper'
import axios from 'axios'
import qs from 'querystring'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.use(VueFormGenerator)

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxSelection,
    DxScrolling,
    GridButton,
    // DxFormItem,
    DxLookup,
    // DxForm,
    // DxSimpleItem,
    // DxGroupItem,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    holeId: {type: Number, default: undefined},
    editable: Boolean,
  },
  data() {
    return {
      selectedRow: [],
      casingData: [],
      optionsComboAssemblyType: [],
      optionsComboGrade: [],
      optionsComboTabularType: [],
      totalLength: 0,
      form: {},
      show: true,
      selectedAction: '',
      disabledCasingAccessories: false,
      tableFields: [
        {
          key: 'index',
          label: 'No',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'assemblyType',
          label: 'Assembly Type',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'runNo',
          label: 'Run No',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'grade',
          label: 'Grade',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'weight',
          label: 'Weight',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
          formatter: function (val) {
            if (val === 0) return ''
            else return val
          },
        },
        {
          key: 'connection',
          label: 'Connection',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'centralizer',
          label: 'Centralizer',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'length',
          label: 'Length',
          sortable: true,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
        {
          key: 'remarks',
          label: 'Remarks',
          sortable: false,
          thClass: 'nowrap',
          tdClass: 'nowrap',
        },
      ],
      perPage: 10,
      currentPage: 1,
      tableBusy: false,
      currRunNo: 1,
    }
  },
  computed: {
    ...formComputed,
    totalRows() {
      if (this.casingData) return this.casingData.length
      else return 0
    },
    /* totalLength() {
      if (Array.isArray(this.casingData)) {
        let tot = 0
        this.casingData.forEach((element) => {
          tot = tot + element.length
        })
        return tot.toFixed(2)
      } else return 0
    }, */
  },
  watch: {
    holeId: function (value) {
      this.refreshGrid()
    },
    editable: function () {},
  },
  created: function () {
    this.init()
    this.loadAllCombo()
  },
  methods: {
    ...formMethods,
    init() {
      this.casingDataSource = new CustomStore({
        key: 'intId',
        load: () => {
          const url = mapApiUrl('/api/form/activity/casing/tally/review')
          const params = {holeId: this.holeId}
          return axios.get(url, {params: params}).then(response => response.data.data)
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
                this.totalLength = 0
                for (const item of result) {
                  this.totalLength += item.length
                }
            }
        },
        insert: (values) => {
          values.holeId = this.holeId
          const url = mapApiUrl('/api/form/activity/casing/tally/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        update: (key, values) => {
          values.intId = key
          const url = mapApiUrl('/api/form/activity/casing/tally/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        remove: (key) => {
        const url = mapApiUrl('/api/form/activity/casing/tally/remove')
        return axios.delete(url, {params: {intId: key}})
        },
      })
    },
    refreshGrid() {
      this.$refs.casingTallyGrid.instance.refresh()
    },
    savedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Casing tally data has been recorded.`, width: 500 }, 'success', 3000)
    },
    updatedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Casing tally data has been updated.`, width: 500 }, 'success', 3000)
    },
    removedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Casing tally data has been removed.`, width: 500 }, 'success', 3000)
    }, 
    refreshTable() {
      this.retrieveDataTable()
    },
    onSelectionChanged(event) {
      this.selectedRow = event.selectedRowsData
    },
    onRowSelected(items) {
      this.selectedRow = []
      if (items.length > 0) {
        this.selectedRow = items
        this.form = items[0]
      }
    },
    loadAllCombo() {
      this.loadComboAssemblyType()
      this.loadComboGrade()
    },
    retrieveDataTable() {
      this.casingData = []
      this.tableBusy = true
      if (this.holeId) {
        this.getActivityCasingTallyList({
          params: { holeId: this.holeId },
        }).then((resp) => {
          if (resp) {
            this.casingData = resp.data.data
            this.currRunNo = 0
            let index = 1
            this.casingData.forEach(casing => {
              casing.id = index++
              if (this.currRunNo < casing.runNo) {
                this.currRunNo = casing.runNo
              }
            })
          }
          // this.currRunNo = resp.data.data.length + 1

          /* this.$nextTick((v) => {
            this.form.runNo = this.currRunNo
          }) */
        })
        this.tableBusy = false
      }
    },
    onSaveOrUpdate(e) {
      let rowData = {}
      if (Array.isArray(e.changes)) {
        rowData = {...e.changes[0].data}        
      } else {
        rowData = {...e.changes.data}
      }
      delete rowData.id
      rowData.holeId = this.holeId
      this.addActivityCasingTally({ params: rowData }).then((resp) => {
          this.retrieveDataTable()
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
        })
    },
    askServerToRemoveData() {
      if (this.selectedRow.length > 0) {
        const data = { ...this.selectedRow[0] }
        this.removeActivityCasingTally({ params: data }).then((resp) => {
          this.retrieveDataTable()
          this.closeModalRemove()
          this.makeToast('Remove data casing success.')
        })
      }
    },
    loadComboAssemblyType() {
      this.getComboListAssemblyType({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboAssemblyType = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboAssemblyType.push(_temp)
        }
      })
    },
    loadComboGrade() {
      this.getComboListGrade({ params: {} }).then((resp) => {
        let _arrData = resp.data.data
        this.optionsComboGrade = []
        for (var i = 0; i < _arrData.length; i++) {
          let _temp = {
            value: _arrData[i].comboId,
            text: _arrData[i].comboValue,
          }
          this.optionsComboGrade.push(_temp)
        }
      })
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    assemblyTypeChanged(val) {
      if (val === 'Casing Accessories') {
        this.disabledCasingAccessories = true
        this.form.grade = ''
        this.form.weight = 0
        this.form.connection = ''
        this.form.centralizer = ''
        this.form.runNo = 0
      } else {
        this.disabledCasingAccessories = false
        
        let i = 0
        for (i=this.casingData.length-1; i>0; i--) {
          if (this.casingData[i].assemblyType === 'Casing') {
            break
          }
        }
        if (i > 0) {
          this.form = {...this.casingData[i]}
        }
        this.form.runNo = this.currRunNo+1
        this.form.length = ''
      }
    },
  },
}
</script>